<template>
  <div class="customerAutoComplete">
    <textarea
      class="customerAutoComplete__textarea col-md-12"
      :rows="row"
      @input="inputAddress"
      v-model="query"
      @keydown.up="up"
      @keydown.down="down"
      @keydown.enter="selectItem($event)"
      @keyup.delete="deleteWord"
    ></textarea>
    <div
      class="customerAutoComplete__listContainer"
      v-show="visible"
      ref="optionsList"
    >
      <ul class="customerAutoComplete__list">
        <li class="customerAutoComplete__listItem" @click="closeList()">
          關閉
        </li>
        <li class="customerAutoComplete__listItem" @click="autoSearchAddress()">
          Google 查詢地址(點選)
        </li>
        <li
          class="customerAutoComplete__listItem customerAutoComplete__listItem--google"
          v-if="isGoogleSearch"
          v-for="(item, index) in googleArray"
          @click="clickGoogleSearch(item)"
        >
          {{ item.name }}
        </li>
        <li
          class="customerAutoComplete__listItem customerAutoComplete__listItem--general"
          v-for="(item, index) in list"
          :key="index"
          :class="{ selected: selected === index }"
          @click="clickAddress(index)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { cookies } from '@/utils/cookies'
import API from '@/assets/js/libs/API'

export default {
  props: {
    gps: {
      default: [],
      type: Array,
    },
    items: {
      default: [],
      type: Array,
    },
    shouldReset: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      itemHeight: 39,
      selectedItem: null,
      selected: null,
      query: '',
      visible: false,
      isGoogleSearch: false,
      googleArray: [],
      geocoder: null,
      service: null,
      getServicePredictionsFn: null,
      isFoundAddress: false,
      isUpOrDownOpt: false,
    }
  },
  watch: {
    query(newVal) {
      if (newVal) {
        this.$emit('input', newVal)
      }
    },
  },
  mounted() {
    this.initData()
    this.query = cookies.get('GladArea')
  },
  methods: {
    closeList() {
      this.visible = false
      this.isFoundAddress = true
    },
    setAddressFromHistory(address) {
      this.isFoundAddress = true
      if (address === null) {
        this.initData()
        return
      }
      this.query = address
    },
    async autoSearchAddress() {
      this.googleArray = []
      try {
        const { result } = await API.get(
          `google/find_address?address=${this.query}`,
        )
        result.map(
          ({ relatedAddress, latitude, longitude, formattedAddress }) => {
            this.googleArray.push({
              name: relatedAddress,
              latitude: latitude,
              longitude: longitude,
              formattedAddress: formattedAddress,
            })
          },
        )
      } catch (error) {
        console.error(error)
      }
      this.isGoogleSearch = true
    },
    clickGoogleSearch(item) {
      let removedAddressKey = item.formattedAddress
        .trim()
        .replace(/\s/, '')
        .replace(/^\d+/, '')
      if (removedAddressKey.slice(0, 2) === '台灣') {
        removedAddressKey = removedAddressKey.slice(2, removedAddressKey.length)
      }
      const object = {
        gps: [item.longitude, item.latitude],
      }
      let isRepeat = item.name.includes(removedAddressKey)
      if (isRepeat) {
        object.address = item.name
      } else {
        object.address = removedAddressKey + '(' + item.name + ')'
      }
      this.query = object.address
      this.visible = false
      this.isGoogleSearch = false
      this.$emit('selected', object)
      this.$emit('clearMainAddress')
      this.isFoundAddress = true
    },
    clearGoogleSearchArray() {
      this.googleArray = []
    },
    inputAddress: _.debounce(function (event) {
      this.isFoundAddress = false
      this.query = event.target.value
      if (this.query.length > 5) {
        this.$emit('changeAddressStatus', this.query)
      }
    }, 1000),
    deleteWord() {
      this.selected = -1
      this.isFoundAddress = false
      this.googleArray = []
    },
    initData() {
      this.query = ''
    },
    clickAddress(index) {
      this.selected = index
      if (!this.items.length) {
        this.$emit('changeAddressStatus', this.query)
        this.isFoundAddress = false
        return
      }
      this.query = this.items[this.selected]
      this.selectedItem = this.items[this.selected]
      this.visible = false

      if (this.gps !== undefined) {
        let finalAddressGPS = this.gps.length
        if (finalAddressGPS !== 0) {
          this.$emit('selected', this.gps[this.selected])
          this.selected = -1
          this.isFoundAddress = true
        } else {
          this.$emit('changeAddressStatus', this.query)
          this.isFoundAddress = false
        }
      }
    },
    selectItem(event) {
      // 還未做選擇
      if (event) event.preventDefault()
      if (!this.isUpOrDownOpt) {
        return
      }
      if (!this.items.length) {
        this.$emit('changeAddressStatus', this.query)
        this.isFoundAddress = false
        return
      }
      this.query = this.items[this.selected]
      this.selectedItem = this.items[this.selected]
      this.visible = false

      if (this.gps !== undefined) {
        let finalAddressGPS = this.gps.length
        if (finalAddressGPS !== 0) {
          this.$emit('selected', this.gps[this.selected])
          this.selected = -1
          this.isFoundAddress = true
        } else {
          this.$emit('changeAddressStatus', this.query)
          this.isFoundAddress = false
        }
      }
    },
    up() {
      if (this.selected > 0) {
        this.selected -= 1
        this.scrollToItem()
        this.isUpOrDownOpt = true
      }
    },
    down() {
      if (this.selected >= this.items.length - 1) {
        return
      }
      this.selected += 1
      this.scrollToItem()
      this.isUpOrDownOpt = true
    },
    scrollToItem() {
      this.$refs.optionsList.scrollTop = this.selected * this.itemHeight
    },
    /* called by parent component */
    getAddress() {
      return this.query
    },
    /* called by parent component */
    setAddress(address) {
      this.query = address
      this.isFoundAddress = true
      this.visible = false
      this.isGoogleSearch = false
      this.googleArray = []
    },
    /* called by parent component */
    clearData() {
      this.selectedItem = null
      this.selected = 0
      this.query = cookies.get('GladArea')
      this.visible = false
      this.isGoogleSearch = false
      this.googleArray = []
      this.isFoundAddress = false
      this.isUpOrDownOpt = false
    },
  },
  computed: {
    list() {
      if (!this.items) {
        this.visible = false
        return []
      }
      this.visible = this.items.length > 0
      if (this.query) {
        if (this.query.length > 5 && !this.isFoundAddress) {
          this.visible = true
          this.$emit('setConfirmLocation')
        } else {
          this.visible = false
        }
        return this.items
      }
      return []
    },
  },
}
</script>

<style scoped lang="scss">
.customerAutoComplete {
  position: relative;
  z-index: 100;
  padding: 0 10px;
  &__textarea {
    padding: 6px 12px;
    font-size: 16px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  &__listContainer {
    padding: 0 10px;
    width: 100%;
    margin-top: 5px;
    position: absolute;
    top: 100%;
    left: 0;
  }

  &__list {
    list-style-type: none;
    padding-left: 0;
    margin: 0;
    border: 2px solid black;
    max-height: 300px;
    overflow-y: auto;
  }

  &__listItem {
    border-bottom: 1px solid lightgray;
    font-size: 16px;
    color: black;
    padding: 10px;
    cursor: pointer;
    background: #f1f1f1;

    &:not(.selected):hover {
      background: #8c8c8c;
      color: black;
    }

    &.selected {
      background: #dfffc7;
      color: #e62e00;
      font-weight: 600;
    }

    &--google {
      background-color: #c2f0c2;
    }

    &--general {
      background-color: #ccebff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/CustomerAutoComplete.vue